import React, { useState, useEffect } from "react"
import { ChangeEvent } from "react"
import { mountEvent } from "../../shared/helpers/input"
import DatePicker, {  } from "react-datepicker"

import "react-datepicker/dist/react-datepicker.css"

import './DateInput.css'

type Props = {
  name: string
  onChange?: (e: ChangeEvent<any>) => any
  value?: Date
  dateFormat?: 'dd/MM/yyyy' | 'yyyy/MM/dd',
  disabled?: boolean
}

export const DateInput: React.FC<Props> = ({
  name,
  dateFormat = 'yyyy/MM/dd',
  onChange,
  value,
  disabled
}) => {
  const [startDate, setStartDate] = useState(value)

  const handleInputChange = (date: Date) => {
    setStartDate(date)
    const rawEvent = mountEvent(name, date)
    onChange?.(rawEvent as ChangeEvent<any>)
  }

  useEffect(() => {
    if (value) {
      setStartDate(value)
    }
  }, [value])

  return (
    <DatePicker dateFormat={dateFormat} selected={startDate} onChange={handleInputChange} placeholderText={dateFormat} disabled={disabled}/>
  )
}
